import crud from './helpers/crud';
import Promise from 'bluebird';
import { servletGet, servletSave, getError } from './helpers';
import join from 'url-join';
import $ from 'jquery';
import JSOG from 'jsog';


export default class SchoolDAO extends crud {
  constructor(urls) {
    super(urls.SCHOOLS_URL);
    this.SCHOOLS_URL = urls.SCHOOLS_URL;
    this.SCHOOL_COUNTS_URL = urls.SCHOOL_COUNTS_URL;
    this.SCHEDULE_IMPORT_URL = urls.SCHEDULE_IMPORT_URL;
    this.CLIENT_SCHEDULE_IMPORT_URL = urls.CLIENT_SCHEDULE_IMPORT_URL;
  }

  getCounts(params = {}, refresh) {
    return servletGet(this.SCHOOL_COUNTS_URL, params, refresh);
  }

  merge({ primary, others }) {
    if (!primary || !others || others.length === 0) {
      return Promise.reject(new Error('Invalid arguments'));
    }

    if (typeof primary !== 'string' || !_.isArray(others) || _.any(others, o => typeof o !== 'string')) {
      return Promise.reject(new Error('Invalid arguments'));
    }

    if (_.contains(others, primary)) {
      return Promise.reject(new Error('Cannot merge school into itself'));
    }

    return servletSave(join(this.SCHOOLS_URL, 'merge'), { primary, others });
  }

  importSchedule({ formData = null }) {
    if (formData === null) {
      return Promise.reject(new Error('FormData is required'));
    }

    if (typeof formData.has === 'function') {
      _.each([ 'league', 'schoolId', 'accountId', 'file' ], requiredKey => {
        if (!formData.has(requiredKey)) {
          return Promise.reject(new Error(`${requiredKey} is required`));
        }
      });
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.SCHEDULE_IMPORT_URL,
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST'
      }).then(
        response => resolve(JSOG.decode(response)),
        jqXhr => reject(getError(jqXhr, 'Failed to import schedule'))
      );
    });
  }

  clientImportSchedule({ formData = null }) {
    if (formData === null) {
      return Promise.reject(new Error('FormData is required'));
    }

    if (typeof formData.has === 'function') {
      _.each([ 'league', 'accountId', 'file' ], requiredKey => {
        if (!formData.has(requiredKey)) {
          return Promise.reject(new Error(`${requiredKey} is required`));
        }
      });
    }

    return new Promise((resolve, reject) => {
      $.ajax({
        url: this.CLIENT_SCHEDULE_IMPORT_URL,
        data: formData,
        processData: false,
        contentType: false,
        type: 'POST'
      }).then(
        response => resolve(JSOG.decode(response)),
        jqXhr => reject(getError(jqXhr, 'Failed to import schedule'))
      );
    });
  }
}


// WEBPACK FOOTER //
// ./src/js/util/dao/SchoolDAO.js